import React, { useState ,useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";

import { DSpinButton } from '../utils/Form';

import { toast } from 'react-toastify';
import { Loader } from '../utils';

import {useParams} from "react-router-dom"
import { BaseUrl, media } from '../../server';

import { getUserById } from '../../redux/actions/user';
function EditUser() {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const [isSpinner, setIsSpinner] = useState(false);
 
  const {id}=useParams()

  useEffect(() => {
    if(erroruserData){
        toast.error(erroruserData)
    }
   dispatch(getUserById(id))
 
  }, [ dispatch ,id]);
 const { isLoading, userData ,erroruserData } = useSelector((state) => state.Users);
  const [name, setName] = useState( userData?.name);
  const [email, setEmail] = useState(userData?.email );
  const [phonNumber, setPhonNumber] = useState(userData?.phoneNumber );
  const [createAt ,setCreateAt]=useState(userData?.createdAt )
  const [role, setRole] = useState(userData?.role);

  const [avatar, setAvatar] = useState(userData?.avatar);
  const [avatarShow, setAvatarShow] = useState({url:`${media}${userData?.avatar}`});

  useEffect(() => {
    if (userData) {
      setName(userData.name );
      setEmail(userData.email );
      setPhonNumber(userData.phoneNumber );
      setCreateAt(userData.createdAt );
      setRole(userData.role);
     
      setAvatar(userData.avatar );
      setAvatarShow({ url: `${media}${userData.avatar}`});
    }
  }, [userData]);


  const Roles=[
{
    id:"User",
    role:"user"
},
{
    id: "Admin",
    role:"admin"
}

  ]
  const UpdateUser = async (newForm) => {
    try {
        const config = { headers: { "Content-Type": "application/json" ,
      
      } , withCredentials: true,
      
    };
        const { data } = await axios.put(`${BaseUrl}/user/${id}`, newForm, config, );

        // عرض رسالة نجاح
        if(data.success){
          toast.success(<span className="font-kufi text-tcolor-4 dark:text-tcolor-1 text-sm">{t("User Role updated successfully!")}</span>);

          // إعادة تعيين الحالات
          setIsSpinner(false);
        }
      

    } catch (error) {
        // عرض رسالة خطأ
        toast.error(error.response?.data?.message);
        setIsSpinner(false);
    }
};
const handleSubmit = (e) => {
  e.preventDefault();
  setIsSpinner(true);
  const newForm = new FormData();

  // إضافة الصورة فقط إذا كانت موجودة وتم تغييرها

  newForm.append("createAt", createAt);
  newForm.append("name", name);
  newForm.append("email", email);
  newForm.append("role", role);
  newForm.append("phonNumber", phonNumber);

  UpdateUser(newForm);
};

  return (<>{
    isLoading  ? (<Loader />) :(
        <div className="w-[90%] bg-back-primery lg:w-[50%] m-2 md:m-10 mt-24 p-2 md:p-10  rounded-3xl">
        <h3 className="text-xl font-semibold text-color-1 font-kufi color text-center">
          {t("Edit User Role")}
        </h3>
     
          <br />
  
      
        <div className='flex relative gap-4 p-5 flex-col items-start justify-start'>
             
        <div class="relative bg-n-1  w-full my-4">
<label for="role" className="block mb-2 text-sm font-medium font-kufi text-tcolor-5  body-1">{t("Change Role")}</label>
    <select 
     className="bg-n-1  font-kufi border border-back-darktertiary/50    focus:outline-none focus:ring-0 focus:border-color-1 peer 0 text-tcolor-5   text-sm rounded-lg focus:ring-color-1 body-1 block w-full p-3"
  
    value={role}
    onChange={(e)=>setRole(e.target.value)}
    name={name}
    >"
    <option selected className=""></option>
    {Roles?.map((data)=>
               <option value={data.role}>
          {t(data.id)}
          </option>
    )}

   
        </select>
</div>



  <div className=" flex gap-2 flex-row justify-center overflow-hidden ">
<p className='text-md text-color-1 font-kufi font-semibold'>{t("Name")} :</p>
<p className='text-lg text-tcolor-4 font-kufi font-medium'>{name}</p>
  </div>
  <div className=" flex gap-2 flex-row justify-center overflow-hidden ">
<p className='text-md text-color-1 font-kufi font-semibold'>{t("Email")} :</p>
<p className='text-lg text-tcolor-4 font-kufi font-medium'>{email}</p>
  </div>

  <div className=" flex gap-2 flex-row justify-center overflow-hidden ">
<p className='text-md text-color-1 font-kufi font-semibold'>{t("Phone Number")} :</p>
<p className='text-lg text-tcolor-4 font-kufi font-medium'>{phonNumber}</p>
  </div>
  <div className=" flex gap-2 flex-row justify-center overflow-hidden ">
<p className='text-md text-color-1 font-kufi font-semibold'>{t("Create At")} :</p>
<p className='text-lg text-tcolor-4 font-kufi font-medium'>{createAt}</p>
  </div>


        
  
        
            <br />
          </div>
          <DSpinButton onClick={handleSubmit} isLoading={isSpinner}>{t("Edit")}</DSpinButton>
    
      </div>
    )
  }</>

  );
}

export default EditUser;